module.exports = __webpack_public_path__ + "img/Partners11.976d07d9.png";